/**
 * Helpers for external app chapter URLs (hosted on usadpbadge.com). Used for itinerary
 * chapters today; may be reused for subapps or other external chapters in the future.
 * Same format as SubAppViewNew extLinkUrl.
 */

const EXTERNAL_APP_BASE_URL = 'https://usadpbadge.com';

/**
 * Builds the full URL for an external app chapter (e.g. itinerary or subapp):
 * https://usadpbadge.com/{pathName}/{subAppId}/{email}/{chapterId}/{progress}/true/true/?lang=...&redirurl=...
 *
 * @param {object} opts - All values used in the URL
 * @param {string} [opts.subAppId] - External app id (e.g. from module.sub_app.id or module.sessionAppId)
 * @param {number} [opts.chapterId] - Session chapter id (e.g. module.session_chapter_id)
 * @param {number} [opts.totalCount] - Total pages (e.g. module.count.total_count)
 * @param {number} [opts.highestPage] - Highest page reached (e.g. module.progress.highest_page)
 * @param {string} [opts.email] - User email
 * @param {string} [opts.langFile] - Language code (e.g. 'en')
 * @param {string} [opts.redirUrl] - Redirect URL after completion (defaults to window.location.href when omitted)
 * @returns {string} Full URL in external app format
 *
 * Path segments are not URI-encoded (same as SubAppViewNew extLinkUrl), so `@` in email stays literal.
 * Query params still use URLSearchParams encoding.
 */
export const getExternalAppChapterUrl = ({
  subAppId = '',
  chapterId = 0,
  totalCount = 0,
  highestPage = 0,
  email = '',
  langFile = 'en',
  redirUrl,
} = {}) => {
  const progress = totalCount <= highestPage ? '0' : highestPage;
  const pathName = totalCount <= highestPage ? 'ret' : 'training';
  let redir = redirUrl != null ? redirUrl : '';
  if (redir === '' && typeof window !== 'undefined') {
    redir = window.location.href;
  }

  const path = `/${pathName}/${subAppId}/${email}/${chapterId}/${progress}/true/true/`;
  const url = new URL(path, EXTERNAL_APP_BASE_URL);
  url.searchParams.set('lang', langFile);
  url.searchParams.set('redirurl', redir);

  return url.href;
};
